"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Screen = void 0;

var _styledComponents = require("styled-components");

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        @media screen and (min-width: ", "px) {\n          ", "\n        }\n      "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Screen = ['xs', 'md', 'lg', 'xl'].reduce(function (map, breakpoint) {
  return Object.assign(map, _defineProperty({}, breakpoint, function (style) {
    return (0, _styledComponents.css)(_templateObject(), function (_ref) {
      var theme = _ref.theme;
      return theme.breakpoint[breakpoint];
    }, style);
  }));
}, {});
exports.Screen = Screen;